import React, { Component } from 'react';
import {
  HashRouter as Router,
  Route,
  withRouter,
} from 'react-router-dom';

//Components
import Header from './components/headerComponent/header.js';
import Footer from './components/footerComponent/footer.js';
import Homepage from './components/pages/homePage.js';
import Contact from './components/pages/contactPage.js';
import Thankspage from './components/pages/thanksPage.js';
import Loadingpage from './components/pages/loadingPage.js';
import Errorpage from './components/pages/errorPage.js';
import Portfolio from './components/pages/portfolioPage.js';

//Includes
import './Assets/css/default.css';

// Reset scroll to top on route change so navigating to a new page always
// starts at the header, not wherever the previous page left the scroll.
class ScrollManager extends Component {
  componentDidMount() { window.scrollTo(0, 0); }
  componentDidUpdate(prev) {
    if (prev.location.pathname !== this.props.location.pathname) window.scrollTo(0, 0);
  }
  render() { return null; }
}
const ScrollManagerWithRouter = withRouter(ScrollManager);

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <ScrollManagerWithRouter />
          <Header />
          <Route exact path='/' component={Homepage} />
          <Route exact path='/Contact' component={Contact} />
          <Route exact path='/Thanks' component={Thankspage} />
          <Route exact path='/Loading' component={Loadingpage} />
          <Route exact path='/Error' component={Errorpage} />
          <Route exact path='/Portfolio' component={Portfolio} />
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
